<template>
  <div class="signin bg_f5 pr">
    <div class="signin-content pa bg_fff">

      <div class="heade pr">
        <img src="https://files.wondercv.com/translate-img/new_wondercv_logo_zh-CN.png" class="logo" alt="">
      </div>

      <div class="pageTips text_center">
        <div class="name f_16 color_40">手机号绑定</div>
        <div class="text f_14 color_9c">绑定手机号可用验证码快速登录</div>
      </div>
      <!-- 手机号样式 -->
      <div class="formBox">
        <div class="formItem flex-c">
          <div class="phoneType f_14 color_40">+86</div>
          <input type="text" class="input flex1 f_16 color_40" placeholder="输入手机" maxlength="11">
        </div>
        <div class="formItem flex-c">
          <input type="text" class="input flex1 f_16 color_40" placeholder="请输入验证码" maxlength="6">
          <div class="getCode cursor_p text_center f_14">
            <span class="color_blue" @click="getCode()" v-if="codeData.time === 60">发送验证码</span>
            <span class="color_90" v-else >{{codeData.time}}s</span>
          </div>
        </div>
        
        <div class="submitButton cursor_p color_fff text_center bg_current f_16" @click="signin()">确认绑定</div>
      </div>


    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      signinType:'phone', // wecht微信，email邮箱，phone手机号，other其他
      codeData:{
        state:false,//是否正在获取验证码
        type:'phone', //当前获取类型
        time:60, //倒计时
      },
      phoneData:{
        phone:'',
        code:'',
      },
    }
  },
  created(){

  },
  mounted () {
    
  },
  methods: {
    getCode(){

    },
    signin(){

    },
  }
}
</script>

<style lang="scss" scoped>
  @import './Signin/Index.scss';
  .signin{
    .pageTips{
      padding: 28px 0 46px;
      .name{
        line-height: 20px;
      }
      .text{
        margin-top: 10px;
        line-height: 18px;
      }
    }
    .formBox{
      padding-top: 0;
    }
  }
</style>